import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { ProductGroup } from 'src/app/order/models/product-group.model';

@Injectable({
  providedIn: 'root'
})
export class ProductGroupService {

  /**
  * Endpoint for http calls
  */
  private _endpoint: string = environment.api.endpoint;

  constructor(private httpClient: HttpClient) { }

  /**
   * Get a product group from the backend by id
   *
   * @param id number id of product group to get
   *
   * @returns Observable<ProductGroup>
   */
  getProductGroupById(id: number): Observable<ProductGroup> {

    if (id <= 0 || id === null || id === undefined) {
      throw new Error('ProductGroupService: Id must be a valid number');
    }

    return this.httpClient.get(this._endpoint + 'product-group/' + id).pipe(map((value: any) => {
      return <ProductGroup>value;
    }));
  }

  getAllProductGroups(): Observable<ProductGroup[]> {
    return this.httpClient.get(this._endpoint + 'product-group?sort=name,ASC').pipe(map((data) => {
      return <ProductGroup[]>data;
    }));
  }

  /**
   * creates a product group in the backend based on product group object.
   *
   * @param productGroup product group object.
   *
   * @returns Observable<ProductGroup>
   */
  createProductGroup(productGroup: ProductGroup): Observable<ProductGroup> {

    if (!productGroup) {
      throw new Error('product group service: you must supply a product group object for saving');
    }

    delete productGroup.createdAt;
    delete productGroup.updatedAt;

    if (productGroup.id > 0) {
      throw new Error('product group service: Cannot create a existing object');
    }

    delete productGroup.id;

    return this.httpClient.post(this._endpoint + 'product-group',
      JSON.stringify(productGroup),
      { headers: { 'Content-Type': 'application/json' } }).pipe(map((data) => {
        return <ProductGroup>data;
      }));
  }

  /**
   * updates a product group in the backend based on product group object.
   *
   * @param productGroup product group object.
   *
   * @returns Observable<ProductGroup>
   */
  updateProductGroup(productGroup: ProductGroup): Observable<ProductGroup> {

    if (!productGroup) {
      throw new Error('product group service: you must supply a product group object for saving');
    }

    delete productGroup.createdAt;
    delete productGroup.updatedAt;

    if (!productGroup.id || productGroup.id === -1) {
      throw new Error('product group service: Cannot update an record without id');
    }

    return this.httpClient.put(this._endpoint + 'product-group/' + productGroup.id,
      JSON.stringify(productGroup),
      { headers: { 'Content-Type': 'application/json' } }).pipe(map((data) => {
        return <ProductGroup>data;
      }));
  }
}
